import { FieldPath } from 'react-hook-form';
import { RequestItem } from '@innowise-group/core';

export enum RequestStepsEnum {
  Main = 0,
  Optional = 1,
  Comments = 2,
}

export const steps = [
  { title: 'pages.candidates.statuses.requirements', value: RequestStepsEnum.Main },
  { title: 'pages.requests.creationModal.conditions', value: RequestStepsEnum.Optional },
  { title: 'pages.candidates.comments.comments', value: RequestStepsEnum.Comments },
];

export const MainSectionFields: FieldPath<RequestItem>[] = [
  'name',
  'customers',
  'isBillable',
  'unitId',
  'divisionId',
  'priority',
  'deadline',
  'professions',
  'domains',
  'requiredCount',
  'forPreoffer',
  'forProject',
  'countries',
  'cities',
  'offices',
];
export const ConditionsSectionFields: FieldPath<RequestItem>[] = [
  'candidateCountry',
  'candidateCity',
  'languages',
  'salaryMin',
  'salaryMax',
  'currency',
  'employmentForms',
  'workFormats',
  'workloads',
];
